import { StyleProp, View, ViewStyle } from "react-native";
import { BACKGROUND_COLOR, BLUR_RADIUS } from "./config";
import BlurView from "../../../../../BlurView";

export type RectangleBlurProps = {
    headerSize?: "small" | "large";
    MaskComponent: React.ComponentType<{ style?: StyleProp<ViewStyle> }>;
};

const HEADER_SIZE_MAP = {
    small: { width: 55, height: 24 },
    large: { width: 95, height: 19 },
};

const BLUR_PROPS = {
    blurRadius: BLUR_RADIUS,
    backgroundColor: BACKGROUND_COLOR,
};

export const RectangleBlur = ({ headerSize }: RectangleBlurProps) => {
    return (
        <>
            <View
                style={{
                    position: "absolute",
                    ...(headerSize
                        ? {
                              width: 321,
                              height: 160,
                          }
                        : {
                              width: "100%",
                              height: "100%",
                          }),

                    bottom: 0,
                }}
            >
                <BlurView {...BLUR_PROPS} />
            </View>
            {headerSize && (
                <View
                    style={{
                        position: "absolute",
                        width: HEADER_SIZE_MAP[headerSize].width,
                        height: HEADER_SIZE_MAP[headerSize].height,
                        top: 0,
                        left: 0,
                    }}
                >
                    <BlurView {...BLUR_PROPS} />
                </View>
            )}
        </>
    );
};
